
export const AuthGDPR = ({ auth,handleChange,error} ) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Informació bàsica sobre protecció de dades
        </h4>
        <p>
          <b>Responsable del tractament:</b> Direcció del centre educatiu.<br />
          <b>Finalitat:</b> Autorització difusió d'imatge/veu i material elaborat als espais de comunicació i difusió del centre.<br />
          <b>Legitimació:</b> Consentiment de l'interessat o de la persona que ostenta la tutoria legal en cas de menors d'edat.<br />
          <b>Destinataris:</b> Les dades no es comunicaran a tercers, excepte en els casos previstos per llei, o si ho heu consentit
          prèviament.<br />
          <b>Drets:</b> Accedir a les dades, rectificar-les, suprimir-les, oposar-se al tractament i sol·licitar-ne la limitació.<br />
          <b>Informació addicional:</b> Podeu consultar la informació addicional i detallada sobre protecció de dades a la pàgina:
        </p>
        <ul>
          <li><a href="https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament" target="_blank" rel="noreferrer">https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament</a> </li>
          <li><a href="https://educacio.gencat.cat/ca/Detall/personal-centres-departament" target="_blank" rel="noreferrer">https://educacio.gencat.cat/ca/Detall/personal-centres-departament</a></li>
        </ul>
        <br />

        <p>
          <input type="checkbox" id="authGDPR" name="authGDPR" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authGDPR">He llegit la informació bàsica sobre protecció de dades i autoritzo el tractament de les meves dades personals.</label>
          <span id="auhtGDPR_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>

    <br />
  </>)
}